
import React, {Component} from "react";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import { faSearch, faSync, faEraser } from "@fortawesome/free-solid-svg-icons";
import AccountTable from "../components/AccountTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AccountManagementService from "../services/AccountManagementService";
import { SUBSCRIPTION } from "../constants/Constants";
import SubscriptionModal from "../components/SubscriptionModal";
import moment from "moment/moment";
import {SECURITY_SERVICE, GRAPHS_SERVICE, ADVANCE_GROUPING_SERVICE, HUMIDITY_SERVICE, SECURITY_SERVICE_NAME, GRAPHS_SERVICE_NAME, ADVANCE_GROUPING_SERVICE_NAME, HUMIDITY_SERVICE_NAME } from "../constants/Constants";

const strings = require('../resources/strings.json');

export default class AccountManagement extends Component {
    state={
        showUpdateModal: false,
        email: "",
        accounts: [],
        accountsTableList: [],
        selectedUser: {},
        searchedUser: ""
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.handleRefreshClick = this.handleRefreshClick.bind(this);
        this.getActiveAccountList = this.getActiveAccountList.bind(this);
        this.validateInput = this.validateInput.bind(this);
        this.changeAccountListForDisplay = this.changeAccountListForDisplay.bind(this);
        this.getSubscriptionStatus = this.getSubscriptionStatus.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.showModal = this.showModal.bind(this);
        this.serviceSelected = this.serviceSelected.bind(this);
        this.selectPremises = this.selectPremises.bind(this);
        this.isValueChanged = this.isValueChanged.bind(this);
        this.updateSubscriptionService = this.updateSubscriptionService.bind(this);
        this.getSecurityService = this.getSecurityService.bind(this);
        this.getGraphsService = this.getGraphsService.bind(this);
        this.getAdvanceGroupService = this.getAdvanceGroupService.bind(this);
        this.getHumidityService = this.getHumidityService.bind(this);
        this.getString = this.getString.bind(this);
        this.checkIfAccountInList = this.checkIfAccountInList.bind(this);
        this.selectedEmail = this.selectedEmail.bind(this);
        this.searchAccounts = this.searchAccounts.bind(this);
    }

    async componentDidMount () {
        await this.getActiveAccountList();
    }


    async getActiveAccountList() {
        try {
            const response = await AccountManagementService.getAccountList();
           this.setState({
            accounts: response
           });
        } catch (e) {
            alert("There was an error fetching accounts");
        }
    }

    changeAccountListForDisplay(accounts) {
        let accountList = [];
        for(const a of accounts) {
            let accountInfo = {};
            accountInfo.email = a.email;
            accountInfo.status = this.getSubscriptionStatus(a.premisesSubscription)
            accountList.push(accountInfo)
            for(const premises of a.premisesSubscription) {
                let premisesInfo = {};
                premisesInfo.userEmail =  a.email;
                premisesInfo.subscription =  a.status;
                premisesInfo.id = premises.id;
                premisesInfo.name = premises.name;
                premisesInfo.deviceCount = premises.deviceCount;
                premisesInfo.security = premises.security;
                premisesInfo.graphs = premises.graphs;
                premisesInfo.advanceGrouping = premises.advanceGrouping;
                premisesInfo.humidity = premises.humidity;
                premisesInfo.subscriptionEndDate = (!premises.subscriptionEndDate) ? "Not Subscribed" : moment.utc(premises.subscriptionEndDate).format("DD-MMM-YYYY");
                premisesInfo.daysForSubscriptionToEnd = premises.daysForSubscriptionToEnd;
                accountList.push(premisesInfo)
            }
        }
        return accountList;
    }

    getSubscriptionStatus(premisesList) {
        for(const premises of premisesList) {
            if(premises.security !== "NONE" || premises.graphs !== "NONE" || premises.advanceGrouping !== "NONE" || premises.humidity !== "NONE") {
                return SUBSCRIPTION.ACTIVE;
            }
        }
        return SUBSCRIPTION.INACTIVE;
    }
    
    handleChange = function (event) {
        if(event.target.value === "") {
            this.setState({ email: event.target.value, searchedUser: "", accountsTableList: [] });
        } else {
            //To filter accounts immediately
            let searchedUser = event.target.value;
            const accountList = this.searchAccounts(searchedUser);
            if(accountList.length === 1) {
                searchedUser = accountList[0].email;
            }
            const accountListDisplay = this.changeAccountListForDisplay(accountList);
            this.setState({ email: event.target.value, searchedUser: searchedUser, accountsTableList: accountListDisplay });
        }
    };

    searchAccounts(value) {
        let likeAccounts = [];
        for(const a of this.state.accounts) {
            if(a.email.startsWith(value)) {
                likeAccounts.push(a);
            }
        }
        return likeAccounts;
    }

    validateInput() {
        if (!this.state.email || this.state.email === "") {
            //Show entire list
            const accountListDisplay = this.changeAccountListForDisplay(this.state.accounts);
            this.setState({
                accountsTableList: accountListDisplay
            })
            return;
        }

        if (!this.validateEmail(this.state.email)) {
            alert("Email Id entered is invalid");
            return;
        }
       

        this.selectedEmail(this.state.email.trim())
    }


    selectedEmail(email) {
        //Fetch values for mentioned account
        const acc = this.checkIfAccountInList(email);
        if(Object.keys(acc).length == 0) {
            //TODO: Make api call to fetch values for inactive acc
            alert(strings.accountDoesNotExist)
            return;
        }
        
        const accountListDisplay = this.changeAccountListForDisplay([acc]);
        this.setState({
            accountsTableList: accountListDisplay
        })
    }

    checkIfAccountInList(email) {
        for(const acc of this.state.accounts) {
            if(acc.email === email) {
                return acc;
            }
        } 
        return {};
    } 


    validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
   


    handleRefreshClick = async () => {
        await this.getActiveAccountList();
        if(this.state.searchedUser && this.state.searchedUser !== "" && this.validateEmail(this.state.searchedUser)) {
            this.selectedEmail(this.state.searchedUser.trim())
        }
        const accountList = this.searchAccounts(this.state.searchedUser);
        if(accountList.length === 1) {
            this.state.searchedUser = accountList[0].email;
        }
        const accountListDisplay = this.changeAccountListForDisplay(accountList);
        this.setState({ accountsTableList: accountListDisplay });
        
    };

    showModal(userInfo) {
        this.setState({showUpdateModal: true, selectedUser: userInfo})
    }

    closeModal() {
        this.setState({showUpdateModal: false, selectedUser: {}})
    }

    async serviceSelected(prevServiceValues, updatedServiceValues) {

        if(!this.isValueChanged(prevServiceValues, updatedServiceValues) && updatedServiceValues.subscriptionMonths === 0) {
            alert("Subscription services were not changed");
            return;
        }
        if(updatedServiceValues.security === "NONE" && updatedServiceValues.graphs === "NONE" && updatedServiceValues.advanceGrouping === "NONE" && updatedServiceValues.humidity === "NONE") {
            alert("Select at least one service to Subscribe");
            return;
        }

        if( updatedServiceValues.subscriptionEndDate === "Not Subscribed" ) {
            alert("Select Subscription End Date.");
            return;
        }

        updatedServiceValues.security = (updatedServiceValues.security === undefined) ? prevServiceValues.security : updatedServiceValues.security;
        updatedServiceValues.graphs = (updatedServiceValues.graphs === undefined) ? prevServiceValues.graphs : updatedServiceValues.graphs;
        updatedServiceValues.advanceGrouping = (updatedServiceValues.advanceGrouping === undefined) ? prevServiceValues.advanceGrouping : updatedServiceValues.advanceGrouping;
        updatedServiceValues.humidity = (updatedServiceValues.humidity === undefined) ? prevServiceValues.humidity : updatedServiceValues.humidity;
        await this.updateSubscriptionService(prevServiceValues.id, updatedServiceValues)
        this.closeModal()
    }

    async updateSubscriptionService(premisesId, updatedServiceValues) {
        try {
            let request ={};
            request.security = this.getSecurityService(updatedServiceValues.security);
            request.graphs = this.getGraphsService(updatedServiceValues.graphs);
            request.advanceGrouping = this.getAdvanceGroupService(updatedServiceValues.advanceGrouping);
            request.humidity = this.getHumidityService(updatedServiceValues.humidity);
            request.subscriptionEndDate = moment.utc(updatedServiceValues.subscriptionEndDate).format("YYYY-MM-DD");
            await AccountManagementService.updateSubscription(premisesId, request)
            this.handleRefreshClick();
        } catch (e) {
            alert(e)
        }
    }

    getSecurityService(security) {
        switch(security) {
            case SECURITY_SERVICE_NAME.NONE: return SECURITY_SERVICE.NONE;
            case SECURITY_SERVICE_NAME.DIY: return SECURITY_SERVICE.DIY;
            case SECURITY_SERVICE_NAME.CONTEXTUAL: return SECURITY_SERVICE.CONTEXTUAL;
            default: return SECURITY_SERVICE.NONE;
        }
    }

    getGraphsService(graphs) {
        switch(graphs) {
            case GRAPHS_SERVICE_NAME.NONE: return GRAPHS_SERVICE.NONE;
            case GRAPHS_SERVICE_NAME.AGGREGATED: return GRAPHS_SERVICE.AGGREGATED;
            case GRAPHS_SERVICE_NAME.COMPLETE: return GRAPHS_SERVICE.COMPLETE;
            default: return GRAPHS_SERVICE.NONE;
        }
    }

    getAdvanceGroupService(advanceGrouping) {
        switch(advanceGrouping) {
            case ADVANCE_GROUPING_SERVICE_NAME.NONE: return ADVANCE_GROUPING_SERVICE.NONE;
            case ADVANCE_GROUPING_SERVICE_NAME.BASIC: return ADVANCE_GROUPING_SERVICE.BASIC;
            case ADVANCE_GROUPING_SERVICE_NAME.ADVANCE: return ADVANCE_GROUPING_SERVICE.ADVANCE;
            default: return ADVANCE_GROUPING_SERVICE.NONE;
        }
    }

    getHumidityService(humidity) {
        switch(humidity) {
            case HUMIDITY_SERVICE_NAME.NONE: return HUMIDITY_SERVICE.NONE;
            case HUMIDITY_SERVICE_NAME.HUMIDITY: return HUMIDITY_SERVICE.HUMIDITY;
            default: return HUMIDITY_SERVICE.NONE;
        }
    }


    isValueChanged(prev, current) {
        return (
            this.getString(prev.security) !== current.security ||
            this.getString(prev.graphs) !== current.graphs ||
            this.getString(prev.advanceGrouping) !== current.advanceGrouping ||
            this.getString(prev.humidity) !== current.humidity ||
            this.getString(prev.subscriptionEndDate) !== current.subscriptionEndDate
        )
    }

    getString(value) {
        return value.replace("_"," ")
    }

    selectPremises (userPremises) {
        this.setState({
            showUpdateModal: true,
            selectedUser: userPremises
        })
    }

    render() {
        return (
            <Container>
                    <Row style={{marginTop: 20}} > <h3> {strings.accountManagement} </h3></Row>
                     <Row style={{marginTop: 20}}>
                      <Form>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Col sm={4}>
                                <Form.Control required type="text" placeholder="name@example.com"  value={this.state.email}
                                              onChange={this.handleChange}/>
                            </Col>
                            <Col sm={1}>
                                <Button variant="primary" onClick={this.validateInput}><FontAwesomeIcon icon={faSearch}/></Button>
                            </Col>
                            <Col sm={1}>
                            <Button variant="primary"  onClick={this.handleRefreshClick}><FontAwesomeIcon icon={faSync}/></Button>
                            </Col>
                            </Form.Group>
                            </Form> 
                     </Row>
                    <Row style={{marginTop: 30}}>
                        <AccountTable 
                            accountList={this.state.accountsTableList}
                            selectPremises={this.selectPremises}
                        />
                    </Row>
                   <SubscriptionModal 
                        user={this.state.selectedUser}
                        show={this.state.showUpdateModal}
                        onCloseClicked={this.closeModal}
                        onUpdate={this.serviceSelected}
                    /> 
            </Container>
        )
    }



}
